module.exports = __webpack_public_path__ + "static/media/prescription.66bfc9e0.png";